import { DateTime } from 'luxon';

import { useZoomDashboardQuery, ZoomDashboardQuery } from 'core/graphql';
import { toApiDate, yesterdayInWarsaw } from 'core/utils/zoomTime';

export type ZoomDashboardData = NonNullable<
  ZoomDashboardQuery['zoomDashboard']
>;

interface IZoomDashboardHook {
  data?: ZoomDashboardData;
  loading: boolean;
  error?: string;
  refetch: () => void;
  startPolling: (interval: number) => void;
  stopPolling: () => void;
}

/**
 * Loads the Zoom dashboard counters for a date range (default: yesterday in
 * Europe/Warsaw). Polling is left to the caller via `startPolling/stopPolling`.
 */
export const useZoomDashboard = (
  range: [DateTime, DateTime] = [yesterdayInWarsaw(), yesterdayInWarsaw()],
): IZoomDashboardHook => {
  const {
    data,
    loading,
    error,
    refetch,
    startPolling,
    stopPolling,
  } = useZoomDashboardQuery({
    variables: {
      dateFrom: toApiDate(range[0]),
      dateTo: toApiDate(range[1]),
    },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    data: data?.zoomDashboard ?? undefined,
    loading,
    error: error?.message,
    refetch: () => {
      refetch();
    },
    startPolling,
    stopPolling,
  };
};
